module.exports.HomepageController = require('./HomepageController')
module.exports.ProjectsController = require('./ProjectsController')
module.exports.ProjectController = require('./ProjectController')
module.exports.StudioController = require('./StudioController')
module.exports.AllProjectsController = require('./AllProjectsController')
module.exports.LegalNoticeController = require('./LegalNoticeController')
